module.exports = __webpack_public_path__ + "media/images/training_case11-21debc704ccbe2d13e9b63f7f04fd691.jpg";